import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_CHART_CONFIG, MISSING_DATA_CONFIG } from "@nexus/widget-kit";

/** What an author sets on the audience trend; the editor renders it (see `defineWidgetSettings`). */
export const settings = defineWidgetSettings({
  id: "piracy-audience-trend",
  extends: [MISSING_DATA_CONFIG, ANIMATE_CHART_CONFIG],
  properties: {
    audienceDisplay: {
      type: "string",
      title: "Audience",
      description:
        "Safety split shows safe and unsafe categories; Total shows their combined audience.",
      default: "split",
      oneOf: [
        { const: "split", title: "Safety split" },
        { const: "line", title: "Total" },
      ],
      "x-ui": { category: "display", order: 10, summary: true, keepDefault: true },
    },
    showDetails: {
      type: "boolean",
      title: "Summary",
      description: "Summary and blocking periods shown around the chart",
      default: false,
      "x-ui": { category: "display", group: "show", order: 20, summary: "Summary" },
    },
    showObserved: {
      type: "boolean",
      title: "Observed traffic",
      description: "Observed CDN traffic for the selected countries, across all platforms",
      default: true,
      "x-ui": { category: "display", group: "show", order: 21, summary: "Observed traffic" },
    },
    showEstimated: {
      type: "boolean",
      title: "Counterfactual traffic",
      description:
        "Model estimate for the selected countries and matching platform group, when available",
      default: true,
      "x-ui": { category: "display", group: "show", order: 22, summary: "Counterfactual" },
    },
    showBlocking: {
      type: "boolean",
      title: "Blocking periods",
      description:
        "Bands for the periods during which blocking ran; grey where it does not reach the selected countries",
      default: true,
      "x-ui": { category: "display", group: "show", order: 23, summary: "Blocking periods" },
    },
    // Which Blocking periods widget drives this chart: a link the host keeps between widgets.
    spotlight: {
      type: "string",
      title: "Blocking spotlight",
      description: "A Blocking periods widget that highlights its period on this chart",
      "x-ui": {
        category: "display",
        order: 75,
        host: "blockingPeriodSelection.driver",
        emptyLabel: "Off",
      },
    },
    spotlightEffect: {
      type: "string",
      title: "Spotlight effect",
      description:
        "Focus dims the rest of the chart and marks the period's peak; Band only emphasizes its band.",
      default: "focus",
      oneOf: [
        { const: "focus", title: "Focus" },
        { const: "band", title: "Band only" },
      ],
      "x-ui": {
        category: "display",
        order: 76,
        visibleIf: { "$blockingPeriodSelection.driver": { set: true } },
      },
    },
    animateChart: {
      description:
        "The audience sweeps in, then the blocking periods and counterfactual appear. Off: drawn at once",
    },
  },
});
